export default "__VITE_ASSET__b7533cd4__"